/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateLevelBody } from '../models';
// @ts-ignore
import type { CreateLevelResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllLevelResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateLevelBody } from '../models';
// @ts-ignore
import type { UploadImageLevelResponse } from '../models';
/**
 * LevelApiApi - axios parameter creator
 */
export const LevelApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateLevelBody} createLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiCreateLevel: async (createLevelBody: CreateLevelBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLevelBody' is not null or undefined
            assertParamExists('levelApiCreateLevel', 'createLevelBody', createLevelBody)
            const localVarPath = `/level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLevelBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiDeleteLevel: async (levelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'levelId' is not null or undefined
            assertParamExists('levelApiDeleteLevel', 'levelId', levelId)
            const localVarPath = `/level/{level_id}`
                .replace('{level_id}', encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiGetAllLevels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiGetLevelById: async (levelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'levelId' is not null or undefined
            assertParamExists('levelApiGetLevelById', 'levelId', levelId)
            const localVarPath = `/level/{level_id}`
                .replace('{level_id}', encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} levelId 
         * @param {UpdateLevelBody} updateLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiUpdateLevel: async (levelId: string, updateLevelBody: UpdateLevelBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'levelId' is not null or undefined
            assertParamExists('levelApiUpdateLevel', 'levelId', levelId)
            // verify required parameter 'updateLevelBody' is not null or undefined
            assertParamExists('levelApiUpdateLevel', 'updateLevelBody', updateLevelBody)
            const localVarPath = `/level/{level_id}`
                .replace('{level_id}', encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLevelBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiUploadLevelImages: async (image: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('levelApiUploadLevelImages', 'image', image)
            const localVarPath = `/level/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LevelApiApi - functional programming interface
 */
export const LevelApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LevelApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateLevelBody} createLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async levelApiCreateLevel(createLevelBody: CreateLevelBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.levelApiCreateLevel(createLevelBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LevelApiApi.levelApiCreateLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async levelApiDeleteLevel(levelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.levelApiDeleteLevel(levelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LevelApiApi.levelApiDeleteLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async levelApiGetAllLevels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.levelApiGetAllLevels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LevelApiApi.levelApiGetAllLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} levelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async levelApiGetLevelById(levelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.levelApiGetLevelById(levelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LevelApiApi.levelApiGetLevelById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} levelId 
         * @param {UpdateLevelBody} updateLevelBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async levelApiUpdateLevel(levelId: string, updateLevelBody: UpdateLevelBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.levelApiUpdateLevel(levelId, updateLevelBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LevelApiApi.levelApiUpdateLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async levelApiUploadLevelImages(image: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageLevelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.levelApiUploadLevelImages(image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LevelApiApi.levelApiUploadLevelImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LevelApiApi - factory interface
 */
export const LevelApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LevelApiApiFp(configuration)
    return {
        /**
         * 
         * @param {LevelApiApiLevelApiCreateLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiCreateLevel(requestParameters: LevelApiApiLevelApiCreateLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLevelResponse> {
            return localVarFp.levelApiCreateLevel(requestParameters.createLevelBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LevelApiApiLevelApiDeleteLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiDeleteLevel(requestParameters: LevelApiApiLevelApiDeleteLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.levelApiDeleteLevel(requestParameters.levelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiGetAllLevels(options?: RawAxiosRequestConfig): AxiosPromise<GetAllLevelResponse> {
            return localVarFp.levelApiGetAllLevels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LevelApiApiLevelApiGetLevelByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiGetLevelById(requestParameters: LevelApiApiLevelApiGetLevelByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLevelResponse> {
            return localVarFp.levelApiGetLevelById(requestParameters.levelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LevelApiApiLevelApiUpdateLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiUpdateLevel(requestParameters: LevelApiApiLevelApiUpdateLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLevelResponse> {
            return localVarFp.levelApiUpdateLevel(requestParameters.levelId, requestParameters.updateLevelBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LevelApiApiLevelApiUploadLevelImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelApiUploadLevelImages(requestParameters: LevelApiApiLevelApiUploadLevelImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageLevelResponse> {
            return localVarFp.levelApiUploadLevelImages(requestParameters.image, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for levelApiCreateLevel operation in LevelApiApi.
 */
export interface LevelApiApiLevelApiCreateLevelRequest {
    readonly createLevelBody: CreateLevelBody
}

/**
 * Request parameters for levelApiDeleteLevel operation in LevelApiApi.
 */
export interface LevelApiApiLevelApiDeleteLevelRequest {
    readonly levelId: string
}

/**
 * Request parameters for levelApiGetLevelById operation in LevelApiApi.
 */
export interface LevelApiApiLevelApiGetLevelByIdRequest {
    readonly levelId: string
}

/**
 * Request parameters for levelApiUpdateLevel operation in LevelApiApi.
 */
export interface LevelApiApiLevelApiUpdateLevelRequest {
    readonly levelId: string

    readonly updateLevelBody: UpdateLevelBody
}

/**
 * Request parameters for levelApiUploadLevelImages operation in LevelApiApi.
 */
export interface LevelApiApiLevelApiUploadLevelImagesRequest {
    readonly image: File
}

/**
 * LevelApiApi - object-oriented interface
 */
export class LevelApiApi extends BaseAPI {
    /**
     * 
     * @param {LevelApiApiLevelApiCreateLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public levelApiCreateLevel(requestParameters: LevelApiApiLevelApiCreateLevelRequest, options?: RawAxiosRequestConfig) {
        return LevelApiApiFp(this.configuration).levelApiCreateLevel(requestParameters.createLevelBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LevelApiApiLevelApiDeleteLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public levelApiDeleteLevel(requestParameters: LevelApiApiLevelApiDeleteLevelRequest, options?: RawAxiosRequestConfig) {
        return LevelApiApiFp(this.configuration).levelApiDeleteLevel(requestParameters.levelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public levelApiGetAllLevels(options?: RawAxiosRequestConfig) {
        return LevelApiApiFp(this.configuration).levelApiGetAllLevels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LevelApiApiLevelApiGetLevelByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public levelApiGetLevelById(requestParameters: LevelApiApiLevelApiGetLevelByIdRequest, options?: RawAxiosRequestConfig) {
        return LevelApiApiFp(this.configuration).levelApiGetLevelById(requestParameters.levelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LevelApiApiLevelApiUpdateLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public levelApiUpdateLevel(requestParameters: LevelApiApiLevelApiUpdateLevelRequest, options?: RawAxiosRequestConfig) {
        return LevelApiApiFp(this.configuration).levelApiUpdateLevel(requestParameters.levelId, requestParameters.updateLevelBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LevelApiApiLevelApiUploadLevelImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public levelApiUploadLevelImages(requestParameters: LevelApiApiLevelApiUploadLevelImagesRequest, options?: RawAxiosRequestConfig) {
        return LevelApiApiFp(this.configuration).levelApiUploadLevelImages(requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }
}

